export default {
  activityDetails: [],
  activityDetailLoadingStatus: 'not loading'
}
